/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const contacts_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M15.745 18.039a.75.75 0 1 0 1.498-.078l-1.498.078Zm-4.987-.078a.75.75 0 0 0 1.498.078l-1.498-.078ZM14 15.936c.567 0 .956.213 1.227.543.288.35.483.885.518 1.56l1.498-.078c-.047-.9-.313-1.772-.858-2.435-.562-.684-1.379-1.09-2.385-1.09v1.5Zm-1.745 2.103c.035-.675.23-1.21.518-1.56.271-.33.66-.543 1.227-.543v-1.5c-1.006 0-1.823.406-2.385 1.09-.545.663-.811 1.535-.857 2.435l1.498.078Zm3.995-7.97c0 1.298-1.024 2.32-2.25 2.32v1.5c2.087 0 3.75-1.726 3.75-3.82h-1.5ZM14 12.39c-1.226 0-2.25-1.022-2.25-2.32h-1.5c0 2.094 1.663 3.82 3.75 3.82v-1.5Zm-2.25-2.32c0-1.297 1.024-2.319 2.25-2.319v-1.5c-2.087 0-3.75 1.727-3.75 3.82h1.5ZM14 7.75c1.226 0 2.25 1.022 2.25 2.32h1.5c0-2.093-1.663-3.82-3.75-3.82v1.5ZM21.75 22V2h-1.5v20h1.5ZM2.25 2v20h1.5V2h-1.5ZM20 .25H7v1.5h13V.25Zm-13 0H4v1.5h3V.25Zm-3 23.5h3v-1.5H4v1.5Zm3 0h13v-1.5H7v1.5ZM6.25 1v22h1.5V1h-1.5Zm-2.5 1A.25.25 0 0 1 4 1.75V.25A1.75 1.75 0 0 0 2.25 2h1.5Zm18 0A1.75 1.75 0 0 0 20 .25v1.5a.25.25 0 0 1 .25.25h1.5Zm-1.5 20a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 21.75 22h-1.5Zm-18 0c0 .966.784 1.75 1.75 1.75v-1.5a.25.25 0 0 1-.25-.25h-1.5Z"
    />
  </svg>
)
export default contacts_medium
